// extracted by mini-css-extract-plugin
module.exports = {"list":"ColorsPage_list__3hcPT","listItem":"ColorsPage_listItem__JvRTM"};